import { create } from "@bufbuild/protobuf";
import { createConnectQueryKey, useQuery, UseQueryOptions } from "@connectrpc/connect-query";

import {
  GetUserBookmarkByExternalIdRequest,
  GetUserBookmarkByExternalIdRequestSchema,
  GetUserBookmarkByExternalIdResponse,
  ListUserBookmarksRequest,
  ListUserBookmarksRequestSchema,
  ListUserBookmarksResponse,
} from "@gx/ts-contracts/services/management/api/user_bookmark_pb";
import {
  getUserBookmarkByExternalId,
  listUserBookmarks,
} from "@gx/ts-contracts/services/management/api/user_bookmark-UserBookmarkService_connectquery";

// ========== LIST USER BOOKMARKS ==========

export const createListUserBookmarksQueryKey = (input?: ListUserBookmarksRequest) => {
  return createConnectQueryKey({
    schema: listUserBookmarks,
    input,
    cardinality: "finite",
  });
};

export const useListUserBookmarksQuery = ({
  input = create(ListUserBookmarksRequestSchema, {}),
  options = {},
}: {
  input?: ListUserBookmarksRequest;
  options?: UseQueryOptions<typeof listUserBookmarks.output, ListUserBookmarksResponse>;
}) => {
  return useQuery<typeof listUserBookmarks.input, typeof listUserBookmarks.output>(
    listUserBookmarks,
    input,
    options,
  );
};

// ========== GET USER BOOKMARK BY EXTERNAL ID ==========

export const createGetUserBookmarkByExternalIdQueryKey = (
  input?: GetUserBookmarkByExternalIdRequest,
) => {
  return createConnectQueryKey({
    schema: getUserBookmarkByExternalId,
    input,
    cardinality: "finite",
  });
};

export const useGetUserBookmarkByExternalIdQuery = ({
  input = create(GetUserBookmarkByExternalIdRequestSchema, {}),
  options = {},
}: {
  input?: GetUserBookmarkByExternalIdRequest;
  options?: UseQueryOptions<
    typeof getUserBookmarkByExternalId.output,
    GetUserBookmarkByExternalIdResponse
  >;
}) => {
  return useQuery<
    typeof getUserBookmarkByExternalId.input,
    typeof getUserBookmarkByExternalId.output
  >(getUserBookmarkByExternalId, input, options);
};
